export const TAB_STENCILS = 'stencils';
export const TAB_FABRICATION = 'fabrication';
export const TAB_PCB_PARTS = 'pcb-parts';
export const TAB_ACCESSORIES = 'accessories';
export const TAB_ASSEMBLY = 'assembly';
